import React from 'react';
import {
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
} from '@mui/material';
import { useImportWizardStore } from '../../store/useImportWizardStore';

/**
 * Radio group for selecting import mode: deals_only or deals_with_addresses.
 * Updates mappingConfig.importMode in the store on change.
 *
 * Validates: Requirements 5.1, 5.3, 5.4
 */
const ImportModeSelector: React.FC = () => {
  const importMode = useImportWizardStore((s) => s.mappingConfig.importMode);
  const updateMappingConfig = useImportWizardStore(
    (s) => s.updateMappingConfig
  );

  // Ensure importMode is set in the store on first render
  React.useEffect(() => {
    if (!importMode) {
      updateMappingConfig({ importMode: 'deals_only' });
    }
  }, [importMode, updateMappingConfig]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value as 'deals_only' | 'deals_with_addresses';
    updateMappingConfig({ importMode: value });
  };

  return (
    <FormControl component="fieldset" fullWidth>
      <FormLabel component="legend" id="import-mode-label">
        Import Mode
      </FormLabel>
      <RadioGroup
        aria-labelledby="import-mode-label"
        name="importMode"
        value={importMode || 'deals_only'}
        onChange={handleChange}
      >
        <FormControlLabel
          value="deals_only"
          control={<Radio />}
          label="Deals Only"
        />
        <FormControlLabel
          value="deals_with_addresses"
          control={<Radio />}
          label="Deals with Addresses"
        />
      </RadioGroup>
    </FormControl>
  );
};

export default ImportModeSelector;
